<div
    class="hidden md:grid md:grid-cols-[1fr_4fr_2fr_1fr] border-solid border-b border-t-0 border-l-0 border-r-0 border-white/40"
>
    <span class="font-semibold text-sm text-shui-text-strong p-5">{{
        'common.request-detail.activity-stream.headers.changed' | translate
    }}</span>
    <span class="font-semibold text-sm text-shui-text-strong p-5">{{
        'common.request-detail.activity-stream.headers.activity' | translate
    }}</span>
    <span class="font-semibold text-sm text-shui-text-strong p-5">{{
        'common.request-detail.activity-stream.headers.by' | translate
    }}</span>
    <span class="font-semibold text-sm text-shui-text-strong p-5">{{
        'common.request-detail.activity-stream.headers.status-change' | translate
    }}</span>
</div>
<div #scrollContainer class="flex-1 min-h-0 overflow-y-auto">
    @for (item of items(); track $index) {
        <div
            class="hidden md:grid md:grid-cols-[1fr_4fr_2fr_1fr] border-solid border-b border-t-0 border-l-0 border-r-0 border-white/10"
        >
            <span class="text-sm text-shui-text-strong p-5 flex items-center truncate text-ellipsis">{{
                item.created | date
            }}</span>
            <span class="text-sm text-shui-text-strong p-5 flex items-center truncate text-ellipsis">{{
                item.action
            }}</span>
            <span class="text-sm text-shui-text-strong p-5 flex items-center truncate text-ellipsis">{{
                item.name
            }}</span>
            <span
                class="text-sm text-shui-text-strong p-5 flex items-center truncate text-ellipsis gap-2 whitespace-nowrap"
            >
                @if (item.status) {
                    <span>{{ 'common.request-detail.activity-stream.to' | translate }}</span>
                    <app-requests-status-pill
                        [status]="item.status"
                        [isOnHold]="false"
                        size="sm"
                    ></app-requests-status-pill>
                } @else {
                    -
                }
            </span>
        </div>
        <div class="md:hidden bg-shui-base-1 rounded-md my-2 p-4 pl-6 flex flex-col gap-6 relative">
            <span class="text-base text-shui-text-strong flex items-center font-semibold text-wrap">{{
                item.action
            }}</span>
            <div class="flex flex-col gap-4">
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-moderate font-semibold">{{
                        'common.request-detail.activity-stream.headers.changed' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong">{{ item.created | date }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-moderate font-semibold">{{
                        'common.request-detail.activity-stream.headers.by' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong">{{ item.name }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-moderate font-semibold mb-1"
                        >{{ 'common.request-detail.activity-stream.headers.status-change' | translate }}
                        {{ 'common.request-detail.activity-stream.to' | translate }}
                    </span>
                    <span class="text-sm text-shui-text-strong">
                        @if (item.status) {
                            <app-requests-status-pill
                                [status]="item.status"
                                [isOnHold]="false"
                                size="sm"
                            ></app-requests-status-pill>
                        } @else {
                            -
                        }
                    </span>
                </div>
            </div>
        </div>
    }

    @if (loading()) {
        <div class="flex flex-col w-full">
            <div class="w-full bg-shui-base-3 h-12 animate-pulse border-b mb-1"></div>
            <div class="w-full bg-shui-base-3 h-12 animate-pulse border-b mb-1 opacity-80"></div>
            <div class="w-full bg-shui-base-3 h-12 animate-pulse border-b mb-1 opacity-60"></div>
            <div class="w-full bg-shui-base-3 h-12 animate-pulse border-b mb-1 opacity-40"></div>
            <div class="w-full bg-shui-base-3 h-12 animate-pulse border-b mb-1 opacity-20"></div>
        </div>
    }

    @if (!loading() && items().length === 0) {
        <div class="flex justify-center items-center">
            <span class="text-sm text-shui-text-subtle p-8">
                {{ 'common.request-detail.activity-stream.no-activities' | translate }}
            </span>
        </div>
    }
</div>
